import "@/lib/zod-jitless";
import { z } from "zod";

export const contactSchema = z.object({
  name: z
    .string()
    .min(2, "Name must be at least 2 characters")
    .max(100, "Name must be under 100 characters"),
  company: z
    .string()
    .min(1, "Company name is required")
    .max(200, "Company name must be under 200 characters"),
  email: z
    .string()
    .email("Please enter a valid email address"),
  phone: z
    .string()
    .regex(/^[+]?[\d\s\-().]{7,20}$/, "Please enter a valid phone number")
    .optional()
    .or(z.literal("")),
  department: z.enum(["sales", "noc", "partnerships", "general"], {
    message: "Please select a department",
  }),
  service: z.enum(
    ["ip-transit", "ethernet-l2vpn", "wavelengths-dwdm", "dark-fiber", "naas", "other"],
    { message: "Please select a service" }
  ).optional(),
  message: z
    .string()
    .min(10, "Message must be at least 10 characters")
    .max(2000, "Message must be under 2000 characters"),
});

export type ContactFormData = z.infer<typeof contactSchema>;

// `value` is what the form submits to the backend and must not change;
// `labelBg` is display text only.
export const departments = [
  { value: "sales" as const, label: "Sales & Quotes", labelBg: "Продажби и оферти" },
  { value: "noc" as const, label: "24/7 NOC (Technical Support)", labelBg: "NOC 24/7 (техническа поддръжка)" },
  { value: "partnerships" as const, label: "Partnerships & Peering", labelBg: "Партньорства и пиъринг" },
  { value: "general" as const, label: "General Enquiry", labelBg: "Общо запитване" },
];

export const services = [
  { value: "ip-transit" as const, label: "IP Transit", labelBg: "IP Transit" },
  { value: "ethernet-l2vpn" as const, label: "Ethernet / L2VPN", labelBg: "Ethernet / L2VPN" },
  { value: "wavelengths-dwdm" as const, label: "Wavelengths (DWDM)", labelBg: "DWDM вълни" },
  { value: "dark-fiber" as const, label: "Dark Fiber", labelBg: "Тъмно влакно" },
  { value: "naas" as const, label: "NaaS Platform", labelBg: "NaaS платформа" },
  { value: "other" as const, label: "Other", labelBg: "Друго" },
];
